import React, { PureComponent } from 'react';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Snackbar } from '@podiumhq/podium-ui';

import withPortal from './withPortal';
const PortalSnackbar = withPortal(Snackbar);

let component;

export default class GlobalSnackbar extends PureComponent {
  static triggerSnackbar(snackbar) {
    _.defer(() => {
      component && component.triggerSnackbar(snackbar);
    });
  }

  constructor(props) {
    super(props);
    this.state = { snackbars: [] };
  }

  componentDidMount() {
    component = this;
  }

  handleDismiss = (id, onDismiss = () => null) => () => {
    onDismiss();

    const snackbars = _.reject(this.state.snackbars, { id });
    this.setState({ snackbars });
  };

  triggerSnackbar = snackbar => {
    const id = uuidv4();
    const { snackbars } = this.state;
    const props = {
      ...snackbar,
      onDismiss: this.handleDismiss(id, snackbar.onDismiss)
    };

    this.setState({
      snackbars: [...snackbars, { id, props }]
    });
  };

  render() {
    return _.map(this.state.snackbars, ({ id, props: { text, ...props } }) => (
      <PortalSnackbar key={id} {...props}>
        {text}&nbsp;
      </PortalSnackbar>
    ));
  }
}
